module.exports = __webpack_public_path__ + "media/images/default/lp_top_achieved_file1-2a9309082c335a68b13e425208500022.svg";